import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useTranslation } from 'react-i18next';
import { Button } from '../button/button';

export const MobileHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Button
      label={t('common.generic.GENERIC_NAVIGATION_BACK')}
      variant="text"
      color="secondary"
      onClick={() => navigate(-1)}
      type="button"
      startIcon={<ChevronLeftIcon />}
      sx={{ p: 1 }}
      size="small"
    />
  );
};
